module.exports = __webpack_public_path__ + "img/microplastics-2.40e2e8f2.png";